import { css } from '@emotion/css';

export const actionBtnsContainer = css`
  background-image: linear-gradient(#ffffff03, var(--bg-primary));
`;

export const messageItemActionOpacityStyle = css`
  --is-hovered: 0;

  .comment-actions {
    opacity: var(--is-hovered, 0);
  }

  &:has(.more-options.open),
  &:has(.reaction-selector.open) {
    --is-hovered: 1;
    background: var(--bg-hover-light);
  }

  :hover {
    --is-hovered: 1;
  }

  @media (max-width: 767px and hover:none) {
    --is-hovered: 1;
  }
`;

export const messageItemActionPositionStyle = css`
  .comment-actions {
    top: -1.2rem;
    right: 1.6rem;
    min-width: 3.2rem !important;

    .icon-button {
      width: 2.6rem !important;
      height: 2.6rem !important;
      padding: 0 !important;
      border-radius: 0.4rem !important;
      border: none !important;
      :hover {
        background: var(--interactive-secondary) !important;
      }
      svg {
        width: 1.8rem !important;
        height: 1.8rem !important;
      }
    }
  }
`;
